import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button, Stack } from '@mui/material';
import { ClockDisplay } from "./ClockDisplay";

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 0.2,
        width: '100%',
        textAlign: 'center',
      }}
    >
      <Typography variant="h6">
        <span>Aktuální čas: </span>
        <ClockDisplay />
      </Typography>

      {/*<Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2 }}>*/}
      {/*  <Button component={Link} to="/navod" variant="text">Návod</Button>*/}
      {/*  <Button component={Link} to="/admin" variant="text">Administrace</Button>*/}
      {/*</Stack>*/}
    </Box>
  );
};

export default Footer;
